import type IconBuilder from '~/components/patterns/icons/builders/iconsData/IconBuilder';
import createIconBuilderFromCondUiKit from './condUiKitAdapter';


// cond-ui-kit icon data (from @conductor/cond-ui-kit/lib/components/icons/ProductIcon/IcoMoonData/question-circle-o.json)
const questionCircleOIconData = {
	icon: {
		attrs: [],
		colorPermutations: {
			'10210410212831741': [],
			'11331341331': [],
			'12402402401': [],
		},
		grid: 14,
		paths: [
			'M581.999 701.998v99.999q0 8.749-5.624 14.374t-14.374 5.624h-99.999q-8.749 0-14.374-5.624t-5.624-14.374v-99.999q0-8.749 5.624-14.374t14.374-5.624h99.999q8.749 0 14.374 5.624t5.624 14.374zM742.002 392q0 31.249-9.376 56.25t-28.437 43.125-32.498 27.502-37.187 22.5q-20.002 11.25-29.064 17.499t-16.249 15-7.186 18.125v20.002q0 8.749-5.624 14.374t-14.374 5.624h-99.999q-8.749 0-14.374-5.624t-5.624-14.374v-42.501q0-21.873 6.564-40.312t15-29.687 24.376-22.187 25.626-15.936 27.811-13.124q33.126-15.627 46.876-26.874t13.75-30.627q0-26.25-27.188-44.687t-59.686-18.439q-35.001 0-59.374 16.877-18.125 12.502-50.001 51.874-5.624 7.5-15.627 7.5-6.874 0-11.875-3.75l-67.5-51.251q-6.25-4.375-7.5-12.502t3.125-14.374q76.249-120 218.127-120 80.624 0 149.064 55.939t68.436 134.064zM512 112.002q-81.251 0-155.311 31.876t-127.5 85.312-85.312 127.5-31.876 155.311 31.876 155.311 85.312 127.5 127.5 85.312 155.311 31.876 155.311-31.876 127.5-85.312 85.312-127.5 31.876-155.311-31.876-155.311-85.312-127.5-127.5-85.312-155.311-31.876zM992 512q0 130.626-64.375 240.936t-174.689 174.689-240.936 64.375-240.936-64.375-174.689-174.689-64.375-240.936 64.375-240.936 174.689-174.689 240.936-64.375 240.936 64.375 174.689 174.689 64.375 240.936z',
		],
		tags: ['question-circle-o'],
	},
	attrs: [],
	properties: {
		code: 60207,
		id: 263,
		name: 'question-circle-o',
		order: 2997,
		prevSize: 20,
	},
	setIdx: 1,
	setId: 1,
	iconIdx: 569,
};

// Create IconBuilder from cond-ui-kit data
const HelpIconBuilder: IconBuilder = createIconBuilderFromCondUiKit(
	questionCircleOIconData as any,
	'#89c32e', // Default green color for new navigation
);

export default HelpIconBuilder;
